import React from "react";
import "./herosection.css";

const HeroSection = () => {
  return (
    <header className="florida-hero">
      <div className="florida-overlay" />
      <div className="florida-text">
        <h1>Florida Man</h1>
        <p>Info Coming Soon!</p>
      </div>
    </header>
  );
};

export default HeroSection;
